/* eslint-disable */

import * as destinationPackageDeliveryService from "../../../services/destinationPackageDelivery";
import * as settings from "../../../services/settings";

import { Button, Col, Row, Spin, Table, notification } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";

import ModalAddPackageToDestination from "./model/ModalAddPackageToDestination";
import { ModalCreateDestinationDeliveryPackage } from "./model/modalCreateDestinationDeliveryPackage";
import { ModalDelete } from "../../model/modal/delete";
import permissions from "../../../../configs/permission";
import { useAccessToken } from "../../../contexts/AccessTokenContext";
import { usePermission } from "../../../hooks/usePermission";
import { useTranslation } from "react-i18next";
import { formatDeliveryStatusLabel } from "../../../utils/deliveryStatusLabel";

const initPage = { limit: 10, page: 1 };

/** Coalesces concurrent fetches with identical params (e.g. React Strict Mode). */
const pendingDestinationDeliveryPackageByKey = new Map();

export const CreateDestinationDeliveryPackage = ({ t, type, detailData, isCreate, setIsCreate }) => {
  const { accessToken } = useAccessToken();
  const { hasPermission, isSuperuser } = usePermission();
  const { i18n } = useTranslation();
  const { t: tOps } = useTranslation("options", { keyPrefix: "Package" });
  const [search, setSearch] = useState(initPage);
  const [destinationPackageData, setDestinationPackageData] = useState([]);

  const [destinationPackageDelivery, setDestinationPackageDelivery] = useState(detailData);
  const [editDestinationDeliveryPackageData, setEditDestinationDeliveryPackage] = useState([]);
  const [addPackageModalOpen, setAddPackageModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  // Delete
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [prepareDeleteData, setPrepareDeleteData] = useState({});

  const [api, contextHolder] = notification.useNotification();
  const canAddPackage = Boolean(
    (detailData && detailData.id) || (destinationPackageDelivery && destinationPackageDelivery.id)
  );
  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onDeleteDestinationDeliveryPackage = async (data) => {
    let prepareData = {
      id: data.id,
    };
    setLoading(true);
    try {
      const response = await destinationPackageDeliveryService.deleteDestinationDeliveryPackage(
        accessToken,
        prepareData
      );
      openNotificationWithIcon(settings.NotificationType.SUCCESS, <>{"Success."}</>, <>{"Delete sale success"}</>);
      setPrepareDeleteData({});
      setIsOpenDelete(false);
      getListDestinationDeliveryPackage(data);
      setLoading(false);
    } catch (err) {
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      console.error(err);
    }
  };

  const getListDestinationDeliveryPackage = async (data) => {
    const destinationDeliveryId =
      (data && data.id) ||
      (destinationPackageDelivery && destinationPackageDelivery.id) ||
      (detailData && detailData.id);
    if (!destinationDeliveryId) return;

    const page = data?.page ?? search.page;
    const limit = data?.limit ?? search.limit;

    const params = {
      id: destinationDeliveryId,
      page,
      limit,
    };

    const requestKey = JSON.stringify(params);
    const existing = pendingDestinationDeliveryPackageByKey.get(requestKey);
    if (existing) {
      return existing;
    }

    const promise = (async () => {
      try {
        const res = await destinationPackageDeliveryService.getDestinationDeliveryPackage(accessToken, params);
        setTotal(res.totalCount);
        setDestinationPackageData(res.queryDestinationDeliveryPackage);
        setSearch({ ...params });
      } catch (err) {
        console.error("[CreateDestinationDeliveryPackage] getListDestinationDeliveryPackage: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
        setLoading(false);
      } finally {
        pendingDestinationDeliveryPackageByKey.delete(requestKey);
      }
    })();

    pendingDestinationDeliveryPackageByKey.set(requestKey, promise);
    return promise;
  };

  useEffect(() => {
    if (!accessToken) return;
    const destinationDeliveryId = detailData && detailData.id;
    if (!destinationDeliveryId) return;

    let cancelled = false;
    const loadPackages = async () => {
      setLoading(true);
      try {
        setDestinationPackageDelivery(detailData);
        await getListDestinationDeliveryPackage({ id: destinationDeliveryId });
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadPackages();
    return () => {
      cancelled = true;
    };
  }, [accessToken, detailData?.id]);

  const columns = [
    {
      title: t("Destination_Delivery_Create.Create_Destination_Delivery_Package.Table_ID"),
      with: "100px",
      dataIndex: "id",
    },
    {
      title: t("Destination_Delivery_Create.Create_Destination_Delivery_Package.Table_Destination_Package"),
      with: "100px",
      dataIndex: "reference",
      render: (_, record) => record.app_destinationpackage.reference || "",
    },
    {
      title: t("Destination_Delivery_Create.Create_Destination_Delivery_Package.Table_Destination_Delivery"),
      with: "100px",
      dataIndex: "destination_delivery",
      render: (_, record) => record.app_destinationdelivery?.vehicle || "-",
    },
    {
      title: t("Destination_Delivery_Create.Create_Destination_Delivery_Package.Table_Delivery_Status"),
      with: "100px",
      dataIndex: "delivery_status",
      render: (_, record) => {
        const label = formatDeliveryStatusLabel(record.delivery_status, i18n.language, tOps);
        return label != null && label !== "" ? label : "-";
      },
    },
    {
      title: t("Destination_Delivery_Create.Create_Destination_Delivery_Package.Table_Total_Received"),
      with: 150,
      dataIndex: "total_received",
      render: (_, record) => record.total_received || "-",
    },
    {
      title: t("Destination_Delivery_Create.Create_Destination_Delivery_Package.Table_Total_sent"),
      with: 150,
      dataIndex: "total_sent",
      render: (_, record) => record.total_sent || "-",
    },
    {
      title: t("Edit", { ns: "common" }),
      with: 150,
      key: "edit",
      render: (_, record) => (
        <Button
          type="link"
          disabled={!hasPermission(permissions.DestinationPackageDelivery.CHANGE)}
          onClick={() => {
            showModal();
            setIsEdit(true);
            setEditDestinationDeliveryPackage(record);
          }}
        >
          <EditOutlined />
        </Button>
      ),
    },
    {
      title: t("Delete", { ns: "common" }),
      with: 150,
      key: "delete",
      render: (_, record) => (
        <Button
          type="link"
          disabled={!hasPermission(permissions.DestinationPackageDelivery.DELETE)}
          onClick={() => {
            setIsOpenDelete(true);
            setPrepareDeleteData(record);
            setIsCreate(true);
          }}
        >
          <DeleteOutlined />
        </Button>
      ),
    },
  ];

  return (
    <>
      {contextHolder}
      <Spin spinning={loading}>
        <Row align="middle" justify="end">
          <Col span={24}>
            <Table
              columns={columns}
              dataSource={destinationPackageData}
              scroll={{ x: "1440px", y: "500px" }}
              rowKey={(record) => record.id}
              pagination={{
                defaultPageSize: search.limit,
                current: search.page,
                pageSize: search.limit,
                total: total,
                onChange: (page, limit) => {
                  getListDestinationDeliveryPackage({ page, limit });
                },
                showSizeChanger: true,
              }}
              style={{ cursor: "pointer" }}
              // onRow={(data) => ({
              //   onClick: () => openModal(data),
              // })}
            />
          </Col>
          <Row justify="end" style={{ marginTop: "10px" }}>
            {hasPermission(permissions.DestinationPackageDelivery.ADD) && (
              <Col span={24}>
                <Button
                  disabled={!canAddPackage}
                  type="primary"
                  onClick={() => setAddPackageModalOpen(true)}
                  style={{ marginRight: "10px", justifyContent: "end" }}
                >
                  {t("Button_Destination_Delivery.BTN_Add_Destination_Delivery_Package")}
                </Button>
              </Col>
            )}
          </Row>
          <ModalCreateDestinationDeliveryPackage
            t={t}
            type={type}
            isModalOpen={isModalOpen}
            handleCancel={handleCancel}
            getListDestinationDeliveryPackage={getListDestinationDeliveryPackage}
            editDestinationDeliveryPackageData={editDestinationDeliveryPackageData}
            detailData={detailData}
            setIsModalOpen={setIsModalOpen}
            isEdit={isEdit}
            setIsCreate={setIsCreate}
            destinationPackageDelivery={destinationPackageDelivery}
          />
          <ModalAddPackageToDestination
            open={addPackageModalOpen}
            setOpen={setAddPackageModalOpen}
            data={detailData && detailData.id ? detailData : destinationPackageDelivery}
            fetchPackage={getListDestinationDeliveryPackage}
          />
        </Row>
        <ModalDelete
          isOpen={isOpenDelete}
          handleCloseModal={() => {
            setIsOpenDelete(false);
          }}
          onClick={() => {
            onDeleteDestinationDeliveryPackage(prepareDeleteData);
          }}
          dataDetail={prepareDeleteData}
          t={t}
        />
      </Spin>
    </>
  );
};
